import React from 'react';
import './index.scss';
import {
  CockpitStatus,
  CockpitType,
  IssueType,
  IssueTypeText,
  CockpitTypeText,
  IssueItem,
  IssueStatus,
  CockpitModeText,
  CockpitMode,
} from '@/utils/type';
import classNames from 'classnames';
import FieldItem from './FieldItem';
import Avatar from '@/assets/images/cockpit/normal-avator.png';
import Timer from '@/assets/images/cockpit/time.png';
import IssueIcon from '@/assets/images/cockpit/issue-num.png';
import IssueDetail from './IssueDetail';
import './index.scss';
import { isEmpty, transIssueDurationTime } from '@/utils/util';
import _ from 'lodash';
export interface CockpitBoardProps {
  cockpitStatus: CockpitStatus;
  cockpitNumber: string;
  cockpitType: CockpitType;
  onlineUser?: string;
  workTimeTotal?: number;
  completedIssueCount?: number;
  issueList?: IssueItem[];
  updateCockpitList: AnyFunc;
  cockpitMode: CockpitMode;
}
const CockpitBoard = (props: CockpitBoardProps) => {
  const {
    cockpitNumber,
    cockpitStatus,
    cockpitType,
    onlineUser,
    workTimeTotal,
    completedIssueCount,
    issueList,
    updateCockpitList,
    cockpitMode,
  } = props;
  const formatIssueList = (source: IssueItem[]) => {
    if (isEmpty(source)) {
      return [];
    }
    const cloneData = _.cloneDeep(source);
    const processIndex = cloneData?.findIndex(
      (item: IssueItem) => item.issueState === IssueStatus.PROCESS
    );
    const element = cloneData?.splice(processIndex, 1);
    !isEmpty(element) && cloneData?.unshift(element[0]);
    return cloneData;
  };
  return (
    <div className="cockpit-board-item">
      <div className="borad-item_header">
        <div className="header-left">
          <i className="icon"></i>
          <i className="label-text">{cockpitNumber}</i>
          {cockpitMode && cockpitStatus !== CockpitStatus.OFFLINE && (
            <>
              <i className="divider"></i>
              <i className="cockpitmode-text">{CockpitModeText[cockpitMode]}</i>
            </>
          )}
        </div>
        <div
          className={classNames('header-right', {
            online:
              cockpitStatus === CockpitStatus.WORK ||
              cockpitStatus === CockpitStatus.REST,
            offline: cockpitStatus === CockpitStatus.OFFLINE,
            monitor: cockpitType === CockpitType.MONITOR_SEAT,
            cockpit: cockpitType === CockpitType.COCKPIT_SEAT,
          })}
        >
          <i className="seat-icon"></i>
          <i className="cockpit-type">{CockpitTypeText[cockpitType]}</i>
        </div>
      </div>
      <div className="issue-solver-info">
        <div className="fields-box">
          <FieldItem label="技术支持" value={onlineUser} icon={Avatar} />
          <FieldItem
            label="今日工作时长"
            value={transIssueDurationTime((workTimeTotal || 0) * 1000)}
            icon={Timer}
          />
          <FieldItem
            label="工单处理数量"
            value={completedIssueCount}
            icon={IssueIcon}
          />
        </div>

        <IssueDetail
          cockpitStatus={cockpitStatus}
          issueList={formatIssueList(issueList || [])}
          updateCockpitList={updateCockpitList}
        />
      </div>
    </div>
  );
};

export default CockpitBoard;
